import { isMoney } from "../../../utils/money";

/* Client-side checks mirror the server's so the admin sees the problem next to
   the field; the server still decides. */

const PERCENT = /^\d{1,2}(\.\d{1,2})?$/;

export function validateBillingSettings(f) {
  const e = {};
  for (const key of ["cgstPercent", "sgstPercent"]) {
    const v = String(f[key] ?? "").trim();
    if (!PERCENT.test(v) || Number(v) > 50) e[key] = "Enter a rate from 0 to 50, e.g. 2.5";
  }
  const days = String(f.retentionDays ?? "").trim();
  if (!/^\d+$/.test(days) || Number(days) > 30) e.retentionDays = "Enter whole days from 0 to 30.";
  const gstin = (f.gstin || "").trim();
  if (gstin && !/^[0-9A-Za-z]{15}$/.test(gstin)) e.gstin = "A GSTIN is 15 letters and digits.";
  return e;
}

export function validateChargeItem(f) {
  const e = {};
  if (!(f.name || "").trim()) e.name = "Name the item.";
  if (!f.categoryId) e.categoryId = "Choose the heading it is billed under.";
  if (!isMoney(f.unitPrice)) e.unitPrice = "Enter the price before GST, e.g. 150 or 19.05";
  return e;
}

/* "2.50" + "2.50" → "5" ; "9" + "9" → "18". For the "GST 5% in total" hint. */
export function totalGstLabel(cgst, sgst) {
  const total = Number(cgst) + Number(sgst);
  if (!Number.isFinite(total)) return "";
  return `${Number(total.toFixed(2))}%`;
}

export const EMPTY_ITEM = {
  name: "", categoryId: "", unitLabel: "", unitPrice: "",
  gstApplicable: true, inDailyGrid: true, isActive: true, hsnSac: "", order: 0,
};
